<template>
  <div class="page flex-col">
    <!-- 顶部导航栏 -->
    <div class="top-bar flex-row">
      <img class="logo" referrerpolicy="no-referrer" src="./assets/img/SketchPng1b873447787c9cbb3e41368859a9d2c662c59bd8506395ceca20ebd4c958e4c0.png" />
      <span class="nav-link" @click="showContact = true">联系我们</span>
    </div>

    <!-- 蓝色横幅 -->
    <div class="banner flex-col">
      <span class="banner-title">基于AI的建筑业数字化建造互联网平台</span>
    </div>

    <!-- 主内容区 -->
    <div class="main-area flex-row">
      <!-- 左侧导航栏 -->
      <div class="sidebar flex-col">
        <div class="nav-item" @click="$router.push('/lanhu_quanguochengshuzihua')">全过程数字化管控</div>
        <div class="nav-item active" @click="$router.push('/lanhu_zhengxiangshejijieduan')">正向设计阶段</div>
        <div class="nav-item" @click="$router.push('/lanhu_heidengshengchanjieduan')">黑灯生产阶段</div>
        <div class="nav-item" @click="$router.push('/lanhu_wurenshigong')">无人/少人施工阶段</div>
        <div class="nav-item" @click="$router.push('/lanhu_zhihuiyunwei')">智慧运维阶段</div>
        <div class="nav-item" @click="$router.push('/lanhu_qita')">其他AI智能体</div>
        <div class="nav-item" @click="showContact = true">定制开发模块</div>
      </div>

      <!-- 右侧内容区 -->
      <div class="content-area flex-row justify-between">
        <!-- 左卡片：新正向设计智能体 -->
        <div class="card-box flex-col">
          <span class="card-title">新正向设计智能体</span>
          <img class="card-icon" referrerpolicy="no-referrer" src="./assets/img/SketchPng88c5306c676a45ec85d922cf15ee2d1102c0bea17f9cca7708f56da10d64d977.png" />
          <span class="card-desc">
            建筑、结构、水、暖、电五个专业各自完成设计图纸，通过一键按钮生成图模一致的BIM模型，二维三维实施联动，提升设计效率、标准化设计流程。
          </span>
          <div class="download-btn flex-col" @click="downloadFile('zhengxiang_sheji_agent')"><span class="btn-text">下载</span></div>
        </div>

        <!-- 右卡片：图纸校对模块 -->
        <div class="card-box flex-col">
          <span class="card-title">图纸校对模块</span>
          <img class="card-icon" referrerpolicy="no-referrer" src="./assets/img/SketchPng602736a8b06d297a46772402a4247e5d6c06e899eb10ae4f8509a34d08147636.png" />
          <span class="card-desc">
            融合图形识别、规则引擎、AI&nbsp;分析、协同管理于一体，替代传统人工逐图复核，实现&nbsp;"自动筛查、精准定位、智能分析、闭环整改、追溯归档"&nbsp;的全流程数字化校对。
          </span>
          <div class="download-btn flex-col" @click="downloadFile('zhengxiang_tuzhi_jiaodui')"><span class="btn-text">下载</span></div>
        </div>
      </div>
    </div>

    <!-- 底部版权信息 -->
    <div class="footer flex-row">
      <img class="footer-logo" referrerpolicy="no-referrer" src="./assets/img/SketchPng23c7966a2d1963c6b88ae89421a6a417dd7b177ac534af52d26b60f665e3e49f.png" />
      <span class="footer-text">
        赢技科技发展（杭州）有限公司&nbsp;
        <br />联系我们：yingji&#64;yjyunjz.com
        <br />版权所有&nbsp;浙ICP备1214545号-1
      </span>
    </div>

    <!-- 联系我们弹窗 -->
    <div class="contact-modal-mask" v-if="showContact" @click.self="showContact = false">
      <div class="contact-modal">
        <div class="contact-modal-header">
          <span class="contact-modal-title">联系我们</span>
          <span class="contact-modal-close" @click="showContact = false">✕</span>
        </div>
        <div class="contact-modal-body">
          <div class="contact-item"><span class="contact-label">公司名称：</span><span class="contact-value">赢技科技发展（杭州）有限公司</span></div>
          <div class="contact-item"><span class="contact-label">联系邮箱：</span><a class="contact-value contact-link" href="mailto:yingji@yjyunjz.com">yingji@yjyunjz.com</a></div>
          <div class="contact-item"><span class="contact-label">官方网站：</span><span class="contact-value">www.yjyunjz.com</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showContact: false,
      downloadLinks: {
        zhengxiang_sheji_agent: 'https://yj-builder.oss-cn-hangzhou.aliyuncs.com/YJZWeb/zhengxiang_sheji_agent.rar',
        zhengxiang_tuzhi_jiaodui: 'https://yj-builder.oss-cn-hangzhou.aliyuncs.com/YJZWeb/zhengxiang_tuzhi_jiaodui.rar'
      }
    };
  },
  methods: {
    downloadFile(key) {
      const url = this.downloadLinks[key];
      if (url) { const link = document.createElement('a'); link.href = url; link.download = key + '.zip'; document.body.appendChild(link); link.click(); document.body.removeChild(link); }
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
.nav-link { cursor: pointer; } .nav-link:hover { opacity: 0.75; }
.download-btn { cursor: pointer; transition: opacity 0.2s, transform 0.15s; }
.download-btn:hover { opacity: 0.85; transform: scale(1.03); }

.contact-modal-mask { position: fixed; top:0; left:0; width:100%; height:100%; background: rgba(0,0,0,0.5); display:flex; align-items:center; justify-content:center; z-index:9999; }
.contact-modal { background:#fff; border-radius:12px; padding:32px 40px; min-width:380px; box-shadow:0 16px 48px rgba(0,0,0,0.2); }
.contact-modal-header { display:flex; align-items:center; justify-content:space-between; margin-bottom:24px; }
.contact-modal-title { font-size:20px; font-weight:700; color:#1a1a2e; }
.contact-modal-close { cursor:pointer; font-size:18px; color:#999; padding:4px; }
.contact-modal-close:hover { color:#333; }
.contact-modal-body { display:flex; flex-direction:column; gap:16px; }
.contact-item { display:flex; align-items:flex-start; font-size:15px; line-height:1.6; }
.contact-label { color:#666; white-space:nowrap; min-width:90px; }
.contact-value { color:#1a1a2e; font-weight:500; }
.contact-link { color:#2563eb; text-decoration:none; }
.contact-link:hover { text-decoration:underline; }
</style>
